import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * One data point, drawn as its series' shape, inside a chart's `<svg>`.
 *
 * About 10px across at every width the chart is drawn: the chart is laid out
 * in real pixels, so a marker never shrinks until its shape can no longer be
 * told apart. A 2px ring in the surface colour keeps it legible where it
 * crosses a line or another series' marker. The hit area is the chart's job,
 * not the marker's — a pointer finds the nearest point within a generous
 * radius, so nobody has to land on the paint.
 */
export function ChartMarker({ shape, cx, cy, fill }) {
    const common = { fill, stroke: 'var(--color-surface)', strokeWidth: 2 };
    if (shape === 'circle')
        return _jsx("circle", { cx: cx, cy: cy, r: 5, ...common });
    if (shape === 'square')
        return _jsx("rect", { x: cx - 4.5, y: cy - 4.5, width: 9, height: 9, ...common });
    if (shape === 'diamond')
        return (_jsx("polygon", { points: `${cx},${cy - 6} ${cx + 6},${cy} ${cx},${cy + 6} ${cx - 6},${cy}`, ...common }));
    return (_jsx("polygon", { points: `${cx},${cy - 6} ${cx + 6},${cy + 4.5} ${cx - 6},${cy + 4.5}`, ...common }));
}
/**
 * A series' whole encoding at legend size: a short run of its line, dash and
 * all, with its marker in the middle. Decorative — the name beside it is the
 * meaning.
 */
export function ChartSeriesSwatch({ style }) {
    return (_jsxs("svg", { viewBox: "0 0 32 14", "aria-hidden": "true", className: "h-3.5 w-8 shrink-0", children: [_jsx("line", { x1: 1, x2: 31, y1: 7, y2: 7, stroke: style.color, strokeWidth: 2, strokeDasharray: style.dash, strokeLinecap: "round" }), _jsx(ChartMarker, { shape: style.shape, cx: 16, cy: 7, fill: style.color })] }));
}
//# sourceMappingURL=ChartMarker.js.map